import React from 'react'
import {
  ATTENDEE_CHECKED_IN,
  ATTENDEE_CREATED,
  ATTENDEE_SIGNED_WAIVER,
  HubspotV2PlatformTag,
  IMPORT_TAG,
} from 'organization/Event/Services/Apps/HubspotV2/index'
import TagInput, {
  TagInputProps,
} from 'organization/Event/Services/Apps/HubspotV2/Config/TagInput'
import {TargetProperty} from 'organization/Event/Services/Apps/HubspotV2/Config'

export default function PlatformTagInput(
  props: Omit<TagInputProps, 'targetTypes' | 'onChange' | 'value'> & {
    value: HubspotV2PlatformTag
    preselectedProperty?: TargetProperty | null
    onChange: (tag: HubspotV2PlatformTag) => void
    errorText?: string
  },
) {
  const {value} = props

  return (
    <TagInput
      targetTypes={['select', 'text', 'checkbox', 'booleancheckbox', 'radio']}
      label={label(value)}
      {...props}
      onChange={(tag) =>
        props.onChange({
          ...value,
          ...tag,
        })
      }
    />
  )
}

function label(tag: HubspotV2PlatformTag) {
  const labels: Record<string, string> = {
    [IMPORT_TAG]: 'Import tag',
    [ATTENDEE_CREATED]: 'Attendee Created',
    [ATTENDEE_SIGNED_WAIVER]: 'Attendee Signed Waiver',
    [ATTENDEE_CHECKED_IN]: 'Attendee Checked In',
  }

  const label = labels[tag.type]
  if (!label) {
    throw new Error(`Label not defined for tag type: ${tag.type}`)
  }

  return label
}
